import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './utils/http'
import {_import} from './utils/theme'
import './utils/vant'
import {reSize} from './utils/resize'

reSize();

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import videojs from 'video.js'
window.videojs = videojs//要先声明,在下方的hls.js中要用到,不然视频会出错
require('videojs-contrib-hls/dist/videojs-contrib-hls.js')
Vue.use(VideoPlayer)

Vue.config.productionTip = false

Vue.prototype.$http = http;
Vue.prototype.$import = _import

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
